import React from 'react';
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { THEME_COLOR, buttonStyles, inputLabelFocusedStyle, selectFocusedStyle } from '../../../theme/formStyles';
import { UNASSIGNED } from '../projectSchedule.utils';

export const SCHEDULE_VIEWS = [
    { value: 'days', label: 'Day list' },
    { value: 'month', label: 'Month' },
    { value: 'team', label: 'Team board' },
    { value: 'gantt', label: '📊 Schedule' },
];

const toggleSx = {
    '& .MuiToggleButton-root': { textTransform: 'none', fontWeight: 500, px: 1.75, py: 0.6, color: '#6b7785' },
    '& .MuiToggleButton-root.Mui-selected': { bgcolor: '#e6f4f2', color: THEME_COLOR, '&:hover': { bgcolor: '#d7eeeb' } },
};

// Month navigation, view switch and the engineer filter for the schedule views.
// The project schedule (Gantt) has its own range, so it hides the month and engineer controls.
export default function ScheduleToolbar({ label, view, onViewChange, onPrev, onNext, onToday, engineers, engineer, onEngineerChange }) {
    const monthly = view !== 'gantt';
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', py: 1.5 }}>
            {monthly && (
                <>
                    <Button variant="outlined" size="small" onClick={onToday} sx={buttonStyles.outlined}>Today</Button>
                    <IconButton size="small" onClick={onPrev} aria-label="Previous month"><ChevronLeftIcon /></IconButton>
                    <IconButton size="small" onClick={onNext} aria-label="Next month"><ChevronRightIcon /></IconButton>
                    <Typography sx={{ fontSize: '17px', fontWeight: 500, minWidth: 130 }}>{label}</Typography>
                </>
            )}
            {!monthly && <Typography sx={{ fontSize: '17px', fontWeight: 500 }}>Project schedule</Typography>}

            {monthly && <FormControl size="small" sx={{ minWidth: 190, ml: { md: 'auto' } }}>
                <InputLabel sx={inputLabelFocusedStyle}>Engineer</InputLabel>
                <Select label="Engineer" value={engineer} onChange={(e) => onEngineerChange(e.target.value)} sx={selectFocusedStyle}
                    MenuProps={{ disableScrollLock: true }}>
                    <MenuItem value="all">Everyone</MenuItem>
                    {engineers.map(e => (
                        <MenuItem key={e.key} value={e.key} sx={e.key === UNASSIGNED ? { color: '#dc2626' } : undefined}>
                            {e.name} ({e.count})
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>}

            <ToggleButtonGroup exclusive size="small" value={view} onChange={(e, v) => v && onViewChange(v)} sx={{ ...toggleSx, ml: monthly ? 0 : 'auto', flexWrap: 'wrap' }}>
                {SCHEDULE_VIEWS.map(v => <ToggleButton key={v.value} value={v.value}>{v.label}</ToggleButton>)}
            </ToggleButtonGroup>
        </Box>
    );
}
